import { branch } from '../clients';
import { API_ENDPOINTS } from '@/config/constants';

/**
 * Branch Manager Address
 */
export interface BranchManagerAddress {
  line: string;
  city: string;
  state: string;
  zipCode: string;
}

/**
 * Branch Manager entity
 */
export interface BranchManager {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  nmlsId: string;
  photoUrl: string | null;
  address: BranchManagerAddress;
  websiteUrl: string | null;
}

/**
 * Branch Address
 */
export interface BranchAddress {
  line: string;
  city: string;
  state: string;
  zipCode: string;
}

/**
 * Branch entity from API
 */
export interface Branch {
  branchId: string;
  name: string;
  address: BranchAddress;
  phone: string;
  email: string;
  branchNmlsId: string;
  websiteUrl: string;
  logoUrl: string;
  photoUrl: string | null;
  branchManagers: BranchManager[];
}

/**
 * Branches API Response
 */
export interface BranchesResponse {
  branches: Branch[];
  totalCount: number;
  pageSize: number;
}

/**
 * Query parameters for fetching branches
 */
export interface GetBranchesParams {
  branchId?: string;
  limit?: number;
  offset?: number;
}

/**
 * Branch Service
 * Handles API calls related to branches
 */
export const branchService = {
  /**
   * Get branches with optional filtering and pagination
   * @param params - Query parameters for filtering and pagination
   * @returns Promise with branches response
   */
  async getBranches(params: GetBranchesParams = {}): Promise<BranchesResponse> {
    const response = await branch.get<BranchesResponse>(
      API_ENDPOINTS.BRANCHES.BASE,
      {
        params: {
          branchId: params.branchId,
          limit: params.limit,
          offset: params.offset,
        },
      }
    );
    return response.data;
  },

  /**
   * Get a single branch by ID
   * @param id - Branch ID
   * @returns Promise with branch data
   */
  async getBranchById(id: string): Promise<Branch> {
    const response = await branch.get<Branch>(API_ENDPOINTS.BRANCHES.BY_ID(id));
    return response.data;
  },
};
